<template>
  <div>
    <i-form label-position="left" :label-width="120" class="default-form">
      <div class="new-form-group">
        <div>
          <Row>
               <i-col span="24" class="default-form-member-col">
              <FormItem label="报销主体" class="new-default-form-item" required>
                <Select
                  v-model="taskFormData.reimburse.main.value"
                  :placeholder="taskFormData.reimburse.main.placeholder"
                >
                  <Option v-for="item in mainList" :key="item.id" :value="item.id">{{item.value}}</Option>
                </Select>
              </FormItem>
            </i-col>
          </Row>
        </div>
        <div>
          <Row>
          </Row>
        </div>
      </div>
    </i-form>
    <i-form
      label-position="left"
      :label-width="120"
      class="default-form reimburse"
      style="margin-top:40px"
    >
    <div v-for="(item, index) in taskFormData.reimburse.items" :key="index" class="one-baoxiao">
      <div>
        <Row class="new-required-label">
          <i-col span="6" class="border-right">
            <FormItem label="实际类别" class="default-form-item" required>
              <!-- <Tooltip :disabled="classificationState === true || item.classification.value.length === 0" :delay="800"> -->
              <div slot="content">{{transformClassification(item.classification.value)}}</div>
              <Cascader :data="newclassificationList" :value="item.classification.value"
                @on-change="classificationChange($event, index,item)" @on-visible-change="classificationVisibleChange"
                trigger="hover" :clearable="false" filterable :placeholder="item.classification.placeholder">
              </Cascader>
              <!-- </Tooltip> -->
            </FormItem>
          </i-col>
          <i-col span="6" class="border-right">
            <FormItem label="项目" class="default-form-item" required>
              <el-select v-model="item.project.value" :placeholder="item.project.placeholder"
                :disabled="item.classification.value.includes(35) || item.classification.value.includes(36) || item.classification.value.includes(38) || item.classification.value.includes(39)"
                filterable>
                <el-option
                  v-show="item.classification.value.includes(35) || item.classification.value.includes(36)|| item.classification.value.includes(38)|| item.classification.value.includes(39)"
                  value='1' label="Operation"></el-option>
                <el-option v-for="_item in projectList" :value="_item.id" :key="_item.id" :label='_item.projectName'>
                </el-option>
              </el-select>
            </FormItem>
          </i-col>
           <i-col span="6" class="border-right">
            <FormItem label="发票类别" class="default-form-item" required>
              <Select v-model="item.category.value" :placeholder="item.category.placeholder"
                @on-change="changeCategory($event, index,item)">
                <Option v-for="_item in categoryList" :key="_item.id" :value="_item.id">{{_item.value}}</Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="6" class="border-right">
            <FormItem label="发票类型" class="default-form-item" required>
              <Select v-model="item.type.value" :placeholder="item.type.placeholder"
                @on-change="changeType($event, index)">
                <template v-if="item.category.value">
                  <Option v-for="_item in typeList" :key="_item.id" :value="_item.id">{{_item.value}}</Option>
                </template>
                <template v-else>
                  <Option disabled value="0">先选择发票类别</Option>
                </template>
              </Select>
            </FormItem>
          </i-col>
        </Row>
        <Row class="new-required-label">
          <i-col span="6" class="border-right">
            <FormItem label="税率" class="default-form-item" required>
              <template v-if="item.type.value ==2">
                <div class="no-fax">—</div>
              </template>
              <template v-else>
                <input-number v-model="item.faxRate.value" :placeholder="item.faxRate.placeholder" :min="0"
                  :formatter="value => `${value}%`" :parser="value => value.replace('%', '')"
                  :readonly="item.type.value ==2"></input-number>
              </template>
            </FormItem>
          </i-col>
          <i-col span="6" class="border-right">
            <FormItem label="总金额" class="default-form-item" required>
              <input-number v-model="item.totalMoney.value" :step="10" :min="0" :readonly="item.category.value == 14"
                :placeholder="item.totalMoney.placeholder" @on-blur="saveTwo(item.totalMoney.value, index)">
              </input-number>
            </FormItem>
          </i-col>
          <i-col span="6" class="border-right">
            <FormItem label="未税金额" class="default-form-item" required>
              <i-input :value="Math.round(item.totalMoney.value / (item.faxRate.value/100 + 1) * 100) / 100" readonly>
              </i-input>
            </FormItem>
          </i-col>
          <i-col span="6" class="border-right">
            <FormItem label="税额" class="default-form-item" required>
              <template v-if="item.type.value != 1">
                <div class="no-fax">—</div>
              </template>
              <template v-else>
                <i-input
                  :value="Math.round((item.totalMoney.value / (item.faxRate.value/100 + 1)) * item.faxRate.value / 100 * 100) / 100"
                  readonly></i-input>
              </template>
            </FormItem>
          </i-col>
        </Row>
        <Row class="new-required-label">
          <i-col span="6" class="border-right">
            <FormItem label="上传发票" class="default-form-item flex-content" required>
              <template v-if="item.showUpload.value">
                <el-upload v-if="!item.invoicePic.value" class="upload-demo" action=""
                  :http-request="(file)=>{homepageUpload('invoicePic',item,file)}"
                  :on-success="(res,file)=>{handleSuccess(item,res,file)}"
                  :on-progress="(event,file,fileList)=>{handleProgress(item,event,file,fileList)}"
                  :show-file-list="false" :on-remove="handleRemove">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <div v-if="!!item.invoicePic.value" class="demo-image__preview">
                     <el-button size="small" type="primary"  @click="lookDeliver(item.invoicePic.name,item.invoicePic.value)">查看链接</el-button>

                  <i class="el-icon-circle-close" @click="removeUrl('invoicePic',item)"> </i>
                </div>
              </template>
              <template v-if="!item.showUpload.value">
                <div class="no-fax">—</div>
              </template>
            </FormItem>
          </i-col>
          <i-col span="6" class="border-right">
            <FormItem label="发生时间" class="default-form-item" required>
              <DatePicker :options="dateOpt[item.category.value || 'default']" transfer :readonly="!item.category.value"
                :multiple="item.category.value == 14" class="new-deadline deadline" type="date"
                :placeholder="item.happenTime.placeholder" format="yyyy-MM-dd" :value="item.happenTime.value"
                @on-change="happenDateChange($event, index)" :clearable="false">
              </DatePicker>
            </FormItem>
          </i-col>
           <i-col span="6" class="border-right">
            <FormItem label="发票号码" class="default-form-item flex-content" required>
              <template v-if="item.showUpload.value">
                    <el-tooltip  class="item" effect="light"
                  content="请提供真实有效的发票" placement="top">
                <el-input placeholder="请输入发票号码" v-model="item.invoiceNumber.value">
                  <div slot="append" @click="gocheckInvoiceNumber()" span="2">发票验证平台</div>
                </el-input>
                </el-tooltip>
              </template>
              <template v-if="!item.showUpload.value">
                <div class="no-fax">—</div>
              </template>
            </FormItem>
          </i-col>
          <i-col span="6" class="border-right">
            <FormItem label="上传支付截图" class="default-form-item flex-content" required>
              <template v-if="item.showUpload.value">
                <el-tooltip v-if="!item.paymentPic.value" class="item" effect="light"
                  content="指银行、支付宝、微信等该笔金额的支付截屏，若非本人则需注释说明。" placement="top">
                  <el-upload v-if="!item.paymentPic.value" class="upload-demo" action=""
                    :http-request="(file)=>{homepageUpload('paymentPic',item,file)}"
                    :on-success="(res,file)=>{handleSuccess(item,res,file)}"
                    :on-progress="(event,file,fileList)=>{handleProgress(item,event,file,fileList)}"
                    :show-file-list="false" :on-remove="handleRemove">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </el-tooltip>
                <div v-if="!!item.paymentPic.value" class="demo-image__preview">
                     <el-button size="small" type="primary"  @click="lookDeliver(item.paymentPic.name,item.paymentPic.value)">查看链接</el-button>
                  <i class="el-icon-circle-close" @click="removeUrl('paymentPic',item)"> </i>
                </div>
              </template>
              <template v-if="!item.showUpload.value">
                <div class="no-fax">—</div>
              </template>
            </FormItem>
          </i-col>
        </Row>
        <Row class="new-required-label ">
           <i-col span="6" class="border-right">
            <FormItem label="账单小票" class="default-form-item flex-content" required>
              <template v-if="item.billingReceipts.toastMsg!==''">
                <el-tooltip class="item" effect="light" :content="item.credentTitle.value" placement="top">
                  <el-upload v-if="!item.billingReceipts.value" class="upload-demo" action=""
                    :http-request="(file)=>{homepageUpload('billingReceipts',item,file)}"
                    :on-success="(res,file)=>{handleSuccess(item,res,file)}"
                    :on-progress="(event,file,fileList)=>{handleProgress(item,event,file,fileList)}"
                    :show-file-list="false" :on-remove="handleRemove">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                  <div v-if="!!item.billingReceipts.value" class="demo-image__preview">
                     <el-button size="small" type="primary"  @click="lookDeliver(item.billingReceipts.name,item.billingReceipts.value)">查看链接</el-button>
                    <i class="el-icon-circle-close" @click="removeUrl('billingReceipts',item)"> </i>
                  </div>
                </el-tooltip>
              </template>
              <template v-if="item.billingReceipts.toastMsg===''">
                <div class="no-fax">—</div>
              </template>
            </FormItem>
          </i-col>
          <i-col span="6" class="border-right">
            <FormItem :label="item.credentTitle.value" class="default-form-item flex-content" required>
              <template v-if="item.showUpload.value">
                <el-tooltip class="item" effect="light" :content="item.credentTitle.value" placement="top">
                  <el-upload v-if="!item.credentialsPic.value" class="upload-demo" action=""
                    :http-request="(file)=>{homepageUpload('credentialsPic',item,file)}"
                    :on-success="(res,file)=>{handleSuccess(item,res,file)}"
                    :on-progress="(event,file,fileList)=>{handleProgress(item,event,file,fileList)}"
                    :show-file-list="false" :on-remove="handleRemove">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                  <div v-if="!!item.credentialsPic.value" class="demo-image__preview">
                     <el-button size="small" type="primary"  @click="lookDeliver(item.credentialsPic.name,item.credentialsPic.value)">查看链接</el-button>
                    <i class="el-icon-circle-close" @click="removeUrl('credentialsPic',item)"> </i>
                  </div>
                </el-tooltip>
              </template>
              <template v-if="!item.showUpload.value">
                <div class="no-fax">—</div>
              </template>
            </FormItem>
          </i-col>
          <i-col span="12" class="border-right">
            <FormItem label="详细说明" class="default-form-item" required>
              <el-tooltip class="item" effect="light" :content="item.detail.placeholder" placement="top">
                <i-input v-model="item.detail.value"
                  :placeholder=" (item.classification.value[1] == 46 ? '请写清楚招待对象，人数，否则拒绝，形式性审核金额' : item.detail.placeholder)">
                </i-input>
              </el-tooltip>
            </FormItem>
          </i-col>
        </Row>
      </div>
    </div>
            <div class="add-btn">
        <a
          v-show="taskFormData.reimburse.items.length > 1"
          href="javascript:;"
          @click="reduceItem()"
          style="color: #FF6666"
        >
          <Icon type="minus-circled"></Icon>删除报销任务
        </a>
        <a href="javascript:;" @click="addItem()">
          <Icon type="plus-circled"></Icon>添加报销任务
        </a>
      </div>
    </i-form>

    <i-form label-position="left" :label-width="120" class="default-form" style="margin-top:40px">
      <div class="new-form-group">
        <div>
          <Row>
            <i-col span="8" class="default-form-member-col">
              <FormItem label="报销总金额" class="new-default-form-item" required>
                <i-input :value="totalMoney" readonly></i-input>
              </FormItem>
            </i-col>
            <i-col span="8" class="default-form-member-col">
              <FormItem label="未税金额" class="new-default-form-item" required>
                <i-input :value="noFaxTotalMoney" readonly></i-input>
              </FormItem>
            </i-col>
            <i-col span="8" class="default-form-member-col">
              <FormItem label="税额" class="new-default-form-item" required>
                <i-input :value="faxMoney" readonly></i-input>
              </FormItem>
            </i-col>
          </Row>
        </div>
      </div>
    </i-form>
    <i-form label-position="left" :label-width="120" class="default-form" style="margin-top:40px">
      <div class="new-form-group">
        <div>
          <Row>
            <i-col span="12" class="default-form-member-col">
              <FormItem :label="'申请人'" class="default-form-item" required>
                <div class="default-form-member-selection">
                  <member-add :is-edit="false" content="添加项目成员" :users="applier"></member-add>
                </div>
                
              </FormItem>
            </i-col>
            <i-col span="12" class="default-form-member-col">
              <FormItem :label="'收款人'" class="default-form-item" required>
                <div class="default-form-member-selection">
                    <!-- <el-select v-model="value" placeholder="请选择">
                      <el-option v-for="item in allUser" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select> -->
                     <el-select v-model="taskFormData.reimburse.payeePeo.value" placeholder="请输入名称进行查询，如Jennifer Shen" filterable>
                <div slot="prefix" class="head-pic">
                  <!-- <Avatar :icon="userInfo.englishName ? '' : 'person'" :src="userInfo.headPic" style="text-aline:center"
                    slot="prefix" size="small">{{userInfo.englishName ? userInfo.englishName.substr(0, 2) : ''}}
                  </Avatar> -->
                </div>
                <el-option v-for="item in allUser" :key="item.id" :label="item.englishName" :value="item.id"
                  >
                </el-option>
              </el-select>
                </div>
              </FormItem>
            </i-col>
          </Row>
        </div>
      </div>
    </i-form>
    <div class="g-ta-r btn">
      <Button type="primary" size="large" :loading="isSubmit" @click="submit">提交</Button>
    </div>

    <toast :is-toast="isToast" :msg="toastMsg"></toast>
  </div>
</template>

<script>
import MemberAdd from "../../../components/MemberAdd";
import Toast from "../../../components/popup/Toast";
import { Task,ScheduleAll } from "../../../API/api";
import { formConf } from "../../../assets/conf/formData.conf";
import uploadMixin from '@/mixin/upload.js';
export default {
  name: "addReimburse",
  mixins: [uploadMixin],
  components: { Toast, MemberAdd },
  computed: {
    TooltipMsg() {},
    //报销总金额
    totalMoney() {
      var total = 0;
      this.taskFormData.reimburse.items.forEach((element, index) => {
        if (element.category.value != 14) {
          total += element.totalMoney.value;
        }
      });
      return Math.round(total * 100) / 100;
    },
    // 餐补金额
    priceMeal() {
      let priceMeal = 0;
      this.taskFormData.reimburse.items.forEach((element, index) => {
        if (element.category.value == 14) {
          priceMeal += element.totalMoney.value;
        }
      });
      return priceMeal;
    },
    //未税总金额
    noFaxTotalMoney() {
      var total = 0;
      this.taskFormData.reimburse.items.forEach((element, index) => {
        if (element.category.value != 14) {
          total +=
            Math.round(
              (element.totalMoney.value / (element.faxRate.value / 100 + 1)) *
                100
            ) / 100;
        }
      });
      return Math.round(total * 100) / 100;
    },
    //税额
    faxMoney() {
      var total = 0;
      this.taskFormData.reimburse.items.forEach((element, index) => {
        if (element.category.value != 14) {
          total +=
            Math.round(
              (((element.totalMoney.value / (element.faxRate.value / 100 + 1)) *
                element.faxRate.value) /
                100) *
                100
            ) / 100;
        }
      });
      return Math.round(total * 100) / 100;
    },
    newclassificationList() {
        var arr = []
        this.$http
        .post(Task.baoxiaoV3, {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") }
        }).then(res=>{
          res.data.retData.forEach(ele => {
          ele.children.forEach(element => {
            var child = [];
            element.children.forEach(e => {
              child.push({
                label:e.label,
                value:Number(e.value)
            })
            })
            arr.push({
              label:element.label,
              value:Number(element.value),
              children:child,
            })
          })
        })
        })
        console.log(arr,'arr')
        return arr
      },

  },
  data() {
    return {
      userInfo:{
        englishName:'',
        headPic:'',
      },
      showUserName:'',
      isToast: false,
      toastMsg: "",
      canSubmit: true,
      isSubmit: false,
      classificationState: false,
      formValue: {
        toolkitId: 18,
        productId: 7,
        // endTime: null,
        taskName: null,
        taskForm: null,
        priceTotal: null,
        priceNoTax: null,
        priceTax: null,
        priceMeal: null,
        operationInfo: [
          {
            operationId: null
          }
        ]
      },
      mainList: [
        //报销主体下拉列表
        {
          id: "1",
          value: "工匠广告传播（上海）有限公司"
        },
        {
          id: "2",
          value: "酷拓文化交流（上海）有限公司"
        },
        {
          id: "3",
          value: "诺锞数字科技（上海）有限公司"
        },
        // {
        //   id: "4",
        //   value: "冀周"
        // },
       {
          id: "5",
          value: "华花世界（上海）文化科技有限公司"
        },
        {
          id: "6",
          value: "颜脂店（上海）文化创意有限公司"
        }
      ],
      categoryList: [
        //报销类别
        {
          id: "1",
          value: "办公费"
        },
        {
          id: "2",
          value: "快递费"
        },
        {
          id: "3",
          value: "业务招待费"
        },
        {
          id: "4",
          value: "市内交通费"
        },
        {
          id: "5",
          value: "低值易耗品"
        },
        {
          id: "6",
          value: "服务费"
        },
        {
          id: "7",
          value: "差旅费"
        },
        {
          id: "8",
          value: "咨询费"
        },
        {
          id: "9",
          value: "员工福利"
        },
        {
          id: "10",
          value: "教育经费"
        },
        {
          id: "11",
          value: "会务费"
        },
        {
          id: "12",
          value: "培训费"
        },
        {
          id: "13",
          value: "固定资产"
        },
        {
          id: "14",
          value: "加班餐补"
        },
        {
          id: "15",
          value: "其他"
        }
      ],
      classificationList: [
        {
          value: 1,
          label: "行政",
          children: [
            {
              value: 2,
              label: "交通费",
              children: [
                {
                  value: 3,
                  label: "出租车票"
                },
                {
                  value: 4,
                  label: "路桥费"
                },
                {
                  value: 5,
                  label: "机票"
                },
                {
                  value: 6,
                  label: "火车票"
                },
                {
                  value: 7,
                  label: "交通费其他"
                }
              ]
            },
            {
              value: 8,
              label: "住宿费",
              children: [
                {
                  value: 9,
                  label: "酒店住宿"
                },
                {
                  value: 10,
                  label: "住宿费其他"
                }
              ]
            },
            {
              value: 11,
              label: "办公环境",
              children: [
                {
                  value: 12,
                  label: "清洁器材及补给"
                },
                {
                  value: 13,
                  label: "保洁劳务费"
                },
                {
                  value: 14,
                  label: "办公环境其他"
                }
              ]
            },
            {
              value: 15,
              label: "办公室基础补给",
              children: [
                {
                  value: 16,
                  label: "办公文具"
                },
                {
                  value: 17,
                  label: "办公室基础补给其他"
                }
              ]
            },
            {
              value: 18,
              label: "杂志订购"
            },
            {
              value: 19,
              label: "项目开销",
              children: [
                {
                  value: 20,
                  label: "快递费"
                },
                {
                  value: 21,
                  label: "劳务费用"
                },
                {
                  value: 22,
                  label: "其他采购"
                },
                {
                  value: 23,
                  label: "其他费用"
                }
              ]
            },
            {
              value: 24,
              label: "行政其他",
              children: [
                {
                  value: 49,
                  label: "个人垫付"
                },
                {
                  value: 50,
                  label: "行政其他"
                },
              ]
            },
            {
              value: 51,
              label: "行政税费",
              children: [
                {
                  value: 52,
                  label: "工商等行政证件获取"
                },
                {
                  value: 53,
                  label: "行政税费其他"
                },
              ]
            },
            {
              value: 54,
              label: "公关",
              children: [
                {
                  value: 55,
                  label: "公关"
                },
                {
                  value: 56,
                  label: "意外金"
                },
                {
                  value: 57,
                  label: "公关其他"
                },
              ]
            },
            {
              value: 58,
              label: "无形资产",
              children: [
                {
                  value: 59,
                  label: "微信微博等注册认证费"
                },
                {
                  value: 60,
                  label: "其他"
                },
              ]
            },
          ]
        },
        {
          value: 25,
          label: "人事",
          children: [
            {
              value: 26,
              label: "招聘类",
              children: [
                {
                  value: 27,
                  label: "内推"
                },
                {
                  value: 28,
                  label: "招聘类其他"
                }
              ]
            },
            {
              value: 29,
              label: "教育类",
              children: [
                {
                  value: 30,
                  label: "讲师费用"
                },
                {
                  value: 31,
                  label: "教材培训"
                },
                {
                  value: 32,
                  label: "委外培训"
                },
                {
                  value: 33,
                  label: "教育类其他"
                }
              ]
            },
            {
              value: 34,
              label: "福利费",
              children: [
                {
                  value: 35,
                  label: "入职体检费"
                },
                {
                  value: 36,
                  label: "福利费其他"
                }
              ]
            },
            {
              value: 37,
              label: "公司文化建设类",
              children: [
                {
                  value: 38,
                  label: "生日会"
                },
                {
                  value: 39,
                  label: "公司文化建设类其他"
                }
              ]
            },
            {
              value: 40,
              label: "津贴类",
              children: [
                {
                  value: 41,
                  label: "餐补"
                },
                {
                  value: 42,
                  label: "津贴类其他"
                }
              ]
            },
            {
              value: 43,
              label: "人事其他"
            }
          ]
        },
        {
          value: 44,
          label: "财务",
          children: [
            {
              value: 45,
              label: "招待费",
              children: [
                {
                  value: 46,
                  label: "餐饮招待"
                },
                {
                  value: 47,
                  label: "其他招待"
                }
              ]
            },
            {
              value: 48,
              label: "",
              label: "财务其他"
            }
          ]
        }
      ],
      typeList: [
        //发表类型下拉列表
        {
          id: "1",
          value: "增值税专用发票"
        },
        {
          id: "4",
          value: "增值税普通发票"
        },
        {
          id: "2",
          value: "其他发票"
        },
        // {
        //   id: "3",
        //   value: "无发票"
        // }
      ],
      projectList: [],
      applier: [],
      dateOpt: {
        14: {},
        default: {
          disabledDate(date) {
            return date;
          }
        }
      },
      mealDate: [],
      // mealPrice: null,
      taskFormData: JSON.parse(JSON.stringify(formConf[18])),
      allUser:[],
    };
  },
  methods: {
       getAllUser() {
       this.$http.post(ScheduleAll.allUsers, this.qs.stringify({}), { headers: { 'Authorization': 'Bearer ' +
       this.$cookie.get('token') } }).then(res => {
       const _data = res.data
       if (_data.retCode === 0) {
       this.allUser = _data.retData.data
       }
       })
       },
     async homepageUpload(type,item,opt) {
     const path = await this.imgUpload(opt,'allImgType');
     console.log(path,'path------')
     switch(type){
     case 'paymentPic':
     item.paymentPic.value=path.url;
     item.paymentPic.name=path.name
     break;
     case 'invoicePic':
     item.invoicePic.value=path.url;
     item.invoicePic.name=path.name

     break;
     case 'credentialsPic':
     item.credentialsPic.value=path.url;
     item.credentialsPic.name=path.name
     break;
    case 'billingReceipts':
     item.billingReceipts.value=path.url;
     item.billingReceipts.name=path.name
     break;
     
     };
     
     this.$forceUpdate();
     },
      lookDeliver(name,url){
       let checkFile=this.checkFile(url);
      console.log(checkFile,'checkFile====')
       if(checkFile=='video'||checkFile=='image'){
        window.open(url,"_blank");

      }else{
        console.log('------12344321')
        this.downloadFile(url,name)

      }
    },
      checkFile(fileValue) {
     let index = fileValue.lastIndexOf("."); //（考虑严谨用lastIndexOf(".")得到）得到"."在第几位
     let fileValueSuffix = fileValue.substring(index); //截断"."之前的，得到后缀
     if (/(.*)\.(mp4|avi|wmv|MP4|AVI|WMV)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合视频格式
     return 'video';
     }else if(/(.*)\.(jpg|JPG|bmp|BMP|mpg|MPG|mpeg|MPEG|tis|TIS|png|jpeg|svgz|pjp| ico|avif| tiff|tif| jfif| svg| xbm| pjpeg| webp|gif|pdf)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合图片格式
     return 'image';
     }else if (/(.*)\.(xls|XLS|xlsx|XLSX|doc|DOC|docx|DOCX|PPT|PPTX|ppt|pptx|m4v)$/.test(fileValueSuffix)) {
     //根据后缀，判断是否符合OFFICE格式
     return 'office';
     }
     return false;
     },
    downloadFile (fileUrl, fileName) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", fileUrl, true);
      console.log('123456')
      xhr.responseType = 'blob';
      xhr.onload=function(e) {
         const url = window.URL.createObjectURL(xhr.response)
        console.log(e,'e------')
      // var url = URL.createObjectURL(e)//传入返回的bobl对象
      let binaryData = [];
      binaryData.push(e);
      let a = document.createElement('a');
      a.target="_blank"
      a.href = url
      a.download = fileName;//修改的文件名
      a.click()
      }
      xhr.send()
      },
     removeUrl(type,item){
      switch(type){
      case 'paymentPic':
      item.paymentPic.value='';
      item.paymentPic.name='';
      break;
      case 'invoicePic':
      item.invoicePic.value='';
      item.invoicePic.name='';

      break;
      case 'credentialsPic':
      item.credentialsPic.value='';
      item.credentialsPic.name='';
      break;
      case 'billingReceipts':
      item.billingReceipts.value='';
      item.billingReceipts.name='';
      break;
      
      };
     this.$forceUpdate();
     },
     handleSuccess(item,res, file){},
     handleRemove(){},
     handleProgress(item,event, file,fileList){},
    gocheckInvoiceNumber(){
      console.log('-------')
      window.open('https://inv-veri.chinatax.gov.cn/','_blank')
    },
    init() {
      this.getApplier();
    },
    saveTwo(val, index) {
      let num = val;
      this.taskFormData.reimburse.items[index].totalMoney.value =
        Math.round(val * 100) / 100;
    },
    changeTitle(e,item,id){
      // title和placeholder的动态变化
    if(e.includes(46)){
    //餐饮招待
   item.credentTitle.value='上传餐饮小票凭证';
    item.detail.placeholder='请填写所有的招待人员姓名及联系方式、招待餐厅名称以及地点、招待事由。';
    }else if(e.includes(35)){
    //入职体检
    item.credentTitle.value='上传体检电子回单';
    item.detail.placeholder='请填写该笔体检费发生的地点。';

    }else if(e.includes(36)){
    //福利类其他
    item.credentTitle.value='上传享受该福利的人员清单';
    item.detail.placeholder='请填写该笔福利费发生的原因。';

    }else if(e.includes(9)){
    //酒店住宿
    item.credentTitle.value='上传酒店机打明细水单';
    item.detail.placeholder='请填写该详述出差的原因（若有同住人员，请说明。）、入住酒店的具体地点。';

    }else if(e.includes(20)){
      item.credentTitle.value='快递单号（快递单：纸质版或手机截图版均可。)';
      item.detail.placeholder='请提供相关说明（若有）。'
    }else if(e.includes(3)||e.includes(4)){
      item.credentTitle.value='上传相关凭证';
      item.detail.placeholder='该次车程的事由、出发地以及目的地。'
    }else if(e.includes(5)||e.includes(6)){
      item.credentTitle.value='上传相关凭证';
      item.detail.placeholder='该次车程的事由。'
    }else{
    item.credentTitle.value='上传相关凭证'
    item.detail.placeholder='输入详细说明';

    }
    //判断类别，符合的都把四个字段必填
    if((e.includes(41)||e.includes(36))&&id!='2'){
    item.showUpload.value=false;
    item.invoiceNumber={
            value: "",
            toastMsg: "",
            name:'',
    };
    item.invoicePic={
            value: "",
            toastMsg: "",
            name:'',
    };
    item.paymentPic={
            value: "",
            toastMsg: "",
            name:'',
    };
    item.credentialsPic={
            value: "",
            toastMsg: "",
            name:'',
    };
    }else{
    item.showUpload.value=true;
    item.invoiceNumber.toastMsg='请输入发票号码';
    item.invoicePic.toastMsg='请上传发票截图';
    item.paymentPic.toastMsg='请上传支付截图';
    item.credentialsPic.toastMsg='请填写'+item.credentTitle.value;
    }
  
    if(e.includes(46)){
      item. billingReceipts.toastMsg='请上传账单小票';   
    }else{
        item.billingReceipts={
            name:'',
            value: "",
            toastMsg: '',
      };
    }
    this.$forceUpdate();
    },
    changeCategory(id, index,item) {
    if (id == 14) {
    this.taskFormData.reimburse.items[index].type.value = "3";
    this.taskFormData.reimburse.items[
    index
    ].happenTime.value = this.mealDate.join(",");
    this.taskFormData.reimburse.items[index].totalMoney.value =
    this.mealDate.length * 20;
    this.taskFormData.reimburse.items[index].faxRate.value = null;
    } else {
    this.taskFormData.reimburse.items[index].type.value = null;
    this.taskFormData.reimburse.items[index].happenTime.value = "";
    this.taskFormData.reimburse.items[index].totalMoney.value = null;
    this.taskFormData.reimburse.items[index].faxRate.value = null;
    }

    this.changeTitle(item.classification.value,item,id)


    },
    classificationChange(e, index,item) {
      console.log(e,'e-----')
      this.taskFormData.reimburse.items[index].project.value = ''
      if (e.includes(35) || e.includes(36) || e.includes(38) || e.includes(39)) {
        this.taskFormData.reimburse.items[index].project.value = '1'
      }
      this.taskFormData.reimburse.items[index].classification.value = JSON.parse('[' + String(e) + ']')  // ["1"] => [1]
      console.log(item,'item------')
      this.changeTitle(e,item,item.category.value)
    },
    classificationVisibleChange(state) {
      this.classificationState = state;
      console.log(state,'state------')
    },
    transformClassification(arr) {
      let vm = this
      let str = "";
      let newArr = [];
      function func(list) {
        for (let i of list) {
          newArr.push(i)

          if (i.children) {
            func(i.children)
          } 
        }
      }


      if (arr.length) {
        func(this.newclassificationList)
        return (newArr.find(ele => ele.value === Number(arr[arr.length - 1]))).label
      }

    },
    getAllowanceDate() {
      this.$http
        .post(Task.availableDate, this.qs.stringify({}), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") }
        })
        .then(res => {
          const _data = res.data;

          if (_data.retCode === 0) {
            this.mealDate = _data.retData;
            this.dateOpt[14] = {
              disabledDate(date) {
                let _year = date.getFullYear();
                let _month = date.getMonth() + 1;
                if (_month < 10) {
                  _month = "0" + _month;
                }
                let _day = date.getDate();
                if (_day < 10) {
                  _day = "0" + _day;
                }
                let _d = `${_year}-${_month}-${_day}`;
                return _data.retData.indexOf(_d) < 0;
              }
            };
          }
        });
    },
    getProject() {
      this.$http
        .post(Task.index, this.qs.stringify({}), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") }
        })
        .then(res => {
          const _data = res.data;
          if (_data.retCode === 0) {
            this.projectList = _data.retData.projectInfo;
            console.log(this.projectList,'this.projectList')
          }
        });
    },
    changeEndTime(date) {
      this.taskFormData.reimburse.endTime.value = date;
    },
    happenDateChange(date, index) {
      this.taskFormData.reimburse.items[index].happenTime.value = date;
      if (this.taskFormData.reimburse.items[index].category.value == 14) {
        this.taskFormData.reimburse.items[index].totalMoney.value =
          (date ? date.split(",").length : 0) * 20;
      }
    },
    
    changeType(id, index) {
      console.log(id,'iid======')
      if (id == 1||id == 4) {
        this.taskFormData.reimburse.items[index].faxRate.value = "6";
      } else {
        this.taskFormData.reimburse.items[index].faxRate.value = null;
      }
      console.log( this.taskFormData.reimburse.items[index].faxRate.value,' this.taskFormData.reimburse.items[index].faxRate.value')
    },
    getApplier() {
      this.applier = [JSON.parse(localStorage.getItem("userInfo"))];
    },
    addItem() {
      let formData = JSON.parse(JSON.stringify(formConf[18])).reimburse
        .items[0];
      console.log(this.taskFormData.reimburse.items,'formdata')
      this.taskFormData.reimburse.items.push(formData);
    },
    reduceItem() {
      this.taskFormData.reimburse.items.pop();
    },
    submit() {
      // this.formValue.endTime = this.taskFormData.reimburse.endTime.value;
      // this.formValue.taskName = this.taskFormData.reimburse.taskName.value;
      this.formValue.taskName = '报销';
      this.formValue.taskForm = JSON.parse(JSON.stringify(this.taskFormData));
      this.formValue.priceTotal = this.totalMoney;
      this.formValue.priceNoTax = this.noFaxTotalMoney;
      this.formValue.priceTax = this.faxMoney;
      this.formValue.priceMeal = this.priceMeal;
      this.formValue.operationInfo[0].operationId = this.applier[0].id;
      let reimburse = this.formValue.taskForm.reimburse;
      let items = this.formValue.taskForm.reimburse.items;
      /* 校验基本信息 */
      for (let prop in reimburse) {
        if (reimburse[prop].toastMsg) {
          console.log(reimburse[prop],'eimburse[prop]')
          if (!reimburse[prop].value) {
            this.canSubmit = false;
            this.toastMsg = reimburse[prop].toastMsg;
            this.isToast = true;
            setTimeout(() => {
              this.isToast = false;
              this.toastMsg = "";
              this.canSubmit = true;
            }, 1500);
          }
        }
      }
      console.log('---------------123')
      /* 校验报销 */
      items.forEach(element => {
        console.log(element,'element')
        for (let _prop_ in element) {
        

          if (_prop_ === "classification") {
            //实际类别
            if (!element[_prop_].value.length) {
                this.canSubmit = false;
                this.toastMsg = element[_prop_].toastMsg;
                this.isToast = true;
                setTimeout(() => {
                  this.isToast = false;
                  this.toastMsg = "";
                  this.canSubmit = true;
                }, 1500);
            }
          } else {
            if (!element[_prop_].value) {
            if (_prop_ === "faxRate") {
              if (element["type"].value == 1) {
                this.canSubmit = false;
                this.toastMsg = element[_prop_].toastMsg;
                this.isToast = true;
                setTimeout(() => {
                  this.isToast = false;
                  this.toastMsg = "";
                  this.canSubmit = true;
                }, 1500);
              }
            }else if(_prop_=='showUpload'||_prop_=='credentTitle'||_prop_=='taskName'){
              //  this.canSubmit=true;
            } else {
              // console.log(element.[],'element----------------------')
              if(element[_prop_].toastMsg!=''){
              this.canSubmit = false;
              this.toastMsg = element[_prop_].toastMsg;
              this.isToast = true;
              setTimeout(() => {
                this.isToast = false;
                this.toastMsg = "";
                this.canSubmit = true;
              }, 1500);
            }
          }
              }
             
          }
          
        }
      });
      if (this.canSubmit) {
        this.isSubmit = true;
        this.$http
          .post(Task.add, this.qs.stringify(this.formValue), {
            headers: { Authorization: "Bearer " + this.$cookie.get("token") }
          })
          .then(res => {
            const _data = res.data;
            this.isToast = true;
            if (_data.retCode === 0) {
              this.toastMsg = "提交成功";
              this.toastState = "success";
            } else {
              this.toastMsg = _data.retMsg;
              this.toastState = null;
            }
            this.isSubmit = false;
            setTimeout(() => {
              this.isToast = false;
              if (_data.retCode === 0) {
                this.$router.push("/myReimburse/list");
              }
            }, 1500);
          });
      }
    }
  },
  created() {
    this.init();
    this.getAllowanceDate();
    this.getProject();
    this.getAllUser();
  }
};
</script>
<style lang="less" >

.reimburse {
  .classification {
    .ivu-cascader {
      width: 147px;
      .ivu-cascader-label {
        line-height: 60px;
        padding: 0 14px;
      }
    }
    .ivu-input {
      text-overflow: ellipsis
    }
  }
}
</style>

<style lang="less" scoped>
.default-form-member-selection{
  /deep/.el-input__inner{
    padding-left: 0;
  }
}
.head-pic {
          display: inline-flex;
          justify-content: center;
          align-items: center;

          /deep/.ivu-avatar-small {
            border-radius: 50%;
            >span{
               
            }
          }
       /deep/   .ivu-avatar-string{
            position: inherit !important;
            left: 0 !important;
          }
        }
.new-form-group{
  >div{
    border-bottom: none;
  }
}
.one-baoxiao{
  border: 1px solid #ced4da;
  border-bottom: none;
  margin-bottom: 20px;
  .border-right{
  border-right: 1px solid #ced4da;

  }
   /deep/.default-form-item {
 .ivu-input-number,.ivu-input-number-input-wrap{
  height: 60px;
  line-height: 60px;
  }
 }
  .flex-content{
  /deep/.ivu-form-item-content{
  height: 60px;
  display: flex ;
  justify-content: center ;
  align-items: center;
  }
  /deep/.demo-image__preview,.ivu-form-item-content{
  height: 100%;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  }
  .el-image{
  margin-right: 5px;
  /deep/.el-icon-circle-close:before{
  color: black;
  }
  }
  .el-icon-circle-close:before{
  color: red;
  }
  }
  .new-required-label{
    border-bottom: 1px solid #ced4da;
    .ivu-input-number{
      height: 60px;
    }
    /deep/.ivu-input-number-handler{
      height: 29px !important;
    }
    /deep/.ivu-input,.ivu-form-item{
      height: 60px !important;
    }
   /deep/ .el-input__inner{
      height: 60px !important;
    }
  }
 /deep/ .ivu-form-item-label{
    padding: 0;
    text-align: center;
    font-size: 14px;
    color: #66707a;
    height: 60px;
    line-height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 5px 0 0 5px;
    background-color: #F1F3F5;
  }
  /deep/.ivu-cascader-label{
          line-height:60px
  }
  /deep/.el-input-group__append{
    border: none;
    padding: 0 5px;
    font-size: 12px;
    cursor: pointer;
    color: #409EFF;
    text-decoration:underline
  }
  .ivu-icon-ios-calendar-outline{
      line-height: 53px !important;
  }
}
.reimburse-form-item {
  height: 40px !important;
  line-height: 40px !important;
}
.items {
  border: 1px solid #ced4da;
  margin-bottom: 20px;
  & > div {
    border-bottom: 1px solid #ced4da;
    display: flex;
    height: 60px;
    font-size: 14px;
    color: #66707a;
    & > div {
      height: 60px;
      // line-height: 60px;
      text-align: center;
      border-right: 1px solid #ced4da;
      &:nth-child(1) {
        width: 150px;
      }
      &:nth-child(2) {
        width: 110px;
      }
      &:nth-child(3) {
        width: 110px;
      }
      &:nth-child(4) {
        width: 90px;
      }
      &:nth-child(5) {
        width: 90px;
      }
      &:nth-child(6) {
        width: 80px;
      }
      &:nth-child(7) {
        width: 80px;
      }
      &:nth-child(8) {
        width: 150px;
      }
      &:nth-child(9) {
        flex: 1;
      }
      &:last-child {
        border: none;
        flex: 1;
      }
    }
    &:first-child {
      height: 36px;
      background: #f8f9fa;
      & > div {
        height: 36px;
        line-height: 36px;
        &::before {
          content: "*";
          display: inline-block;
          margin-right: 4px;
          line-height: 1;
          font-family: SimSun;
          font-size: 12px;
          color: #ed3f14;
        }
      }
    }
    &:last-child {
      border: none;
    }
  }
}
.add-btn {
  text-align: right;
  margin-bottom: 16px;
  a {
    margin-left: 16px;
    font-size: 14px;
  }
}
.btn {
  margin-top: 40px;
}
.no-fax {
  background-color: white;
  height: 59px;
  line-height: 59px;
  display: flex;
  align-items: center;
  justify-content: center;
  // border-bottom: 1px solid #ced4da;
}
</style>

